import React, { Component, Fragment } from "react";
import aggregacao from "../../aggregacao";
import chartConfig from "../../chartConfig";
import LinhaCurso from "./LinhaCurso";

export default class LinhaModalidade extends Component {

    constructor(props) {
        super(props);
        this.state = { expandido: false };
    }

    alternarExpansao = () => {
        this.setState((estadoAnterior) => ({ expandido: !estadoAnterior.expandido }));
    }

    render() {
        let { linha, linhasCube, mes } = this.props;
        let { expandido } = this.state;
        let cursos = expandido ? aggregacao.resumoPorCurso(linhasCube, mes) : [];

        return (
            <Fragment>
                <tr>
                    <td onClick={this.alternarExpansao} className="pointer">
                        {expandido ? "▾" : "▸"} {linha.modalidade}
                    </td>
                    {aggregacao.COLUNAS_RESUMO_MODALIDADE.map((campo) => (
                        <td key={campo}>{chartConfig.formatarNumeroPtBr(linha[campo])}</td>
                    ))}
                </tr>

                {expandido && cursos.map((curso) => (
                    curso.id === "TOTAL" ? (
                        <tr key="TOTAL" className="table-light">
                            <td style={{ paddingLeft: "2rem" }}>{curso.curso}</td>
                            {aggregacao.COLUNAS_RESUMO_MODALIDADE.map((campo) => (
                                <td key={campo}>{chartConfig.formatarNumeroPtBr(curso[campo])}</td>
                            ))}
                        </tr>
                    ) : (
                        <LinhaCurso key={curso.id} curso={curso} linhasCube={linhasCube.filter((l) => l.id === curso.id)} />
                    )
                ))}
            </Fragment>
        )
    }
}
